// Vendors
import React from 'react';
// Components
import { LineSeparatorComponent } from '@openbank/ziniaweb-ui-components';
import { FINANCIAL_DATA_SEPARATOR_PROPS } from './constants/financial-data-separator.constants';

const FinancialDataSeparator = (): React.JSX.Element => (
    <LineSeparatorComponent {...FINANCIAL_DATA_SEPARATOR_PROPS} />
);

export { FinancialDataSeparator };
